module.exports = __webpack_public_path__ + "img/rrss3.918e7114.jpg";